import React from "react";
import { Transaction } from "../constants/enums";
import { FormattedNumber } from "react-intl";
import Fade from '@material-ui/core/Fade';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const TransactionTable = ({ transactions, accounts, counterparties, operations, onTransactionDelete }) => (
    <Fade in={transactions.length > 0}>
        <Table padding="checkbox">
            <TableHead>
                <TableRow>
                    <TableCell>Дата</TableCell>
                    <TableCell>Статья ДДС</TableCell>
                    <TableCell>Подразделение</TableCell>
                    <TableCell>Учетный счет</TableCell>
                    <TableCell>Сумма</TableCell>
                    <TableCell>Комментарий</TableCell>
                    <TableCell>&nbsp;</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {transactions.map(({
                paymentDate,
                operation,
                counterparty,
                account,
                department,
                sum,
                comment }, i) => {
                    const foundedOperation = operations.find(o => o._id === operation) || {};
                    const foundedAccount = accounts.find(a => a._id === account) || {};
                    return (
                        <TableRow key={i}>
                            <TableCell>{ paymentDate }</TableCell>
                            <TableCell>{ foundedOperation.name || "???" }</TableCell>
                            <TableCell>{ Transaction.Departments[department] }</TableCell>
                            <TableCell>{ foundedAccount.name || "???" }</TableCell>
                            <TableCell>
                                <FormattedNumber value={ {"DEBIT": 1, "CREDIT": -1}[foundedOperation.side] * Number(`${sum}`.replace(/\s/g,``))}
                                                 style={`currency`}
                                                 currency="RUB"
                                                 minimumFractionDigits={0} />
                            </TableCell>
                            <TableCell>{ comment }</TableCell>
                            <TableCell>
                                <IconButton onClick={e => {e.preventDefault(); onTransactionDelete(i)}}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                )}
            )}
            </TableBody>
        </Table>
    </Fade>
);

export default TransactionTable;



// WEBPACK FOOTER //
// ./src/components/TransactionTable.js